import { createGlobalStyle } from 'styled-components';
import isInCCLiframe from '../utils/isInCCLiframe';

const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        background: ${({ theme }: any) =>
          isInCCLiframe ? '#f8f8f8' : theme.colors.primary[10]};

        .place-top.type-custom::before {
            background-color: transparent;
        }
    }
`;

export default GlobalStyle;
